import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

// Stimulus keeps one native listener per element that carries a data-action,
// in a Map keyed by the element (Dispatcher#eventListenerMaps). When such an
// element leaves the DOM while its controller lives on, the binding is
// disconnected but the map entry — element, listener and the subtree under
// it — stays for the life of the Application, which under Turbo is the whole
// session. Every floor repaint swaps hundreds of tile polygons that each
// carry `click->…#walkTo`, so a long evening walked a heap of dead floors
// around: a heap snapshot after lair → hollow → lair held 591 detached
// polygons under `Stimulus.dispatcher.eventListenerMaps`. Stimulus already
// knows how to clear an emptied listener (it does so on controller
// disconnect, with the second argument); this asks for it on every
// disconnect. Verified with @hotwired/stimulus 3.2.2; the hook is the
// dispatcher's own public method and the flag it already accepts.
const dispatcher = application.dispatcher
const bindingDisconnected = dispatcher.bindingDisconnected.bind(dispatcher)
dispatcher.bindingDisconnected = (binding) => bindingDisconnected(binding, true)

export { application }
